<template>
  <div class="container">
    <img class="invite" src="../../assets/images/share/inviteCode@3x.png" width="100%" />
    <div class="title">分享越多，回饋越多！</div>
    <section class="desc-wrap">
      <div class="flex-row">
        <div class="step">1</div>
        <div class="text">分享你的優惠序號</div>
      </div>

      <div class="flex-row">
        <div class="step">2</div>
        <div>
          <div class="text">朋友輸入優惠序號後 30 日內使用悠遊付消費 100 元</div>
          <div class="text-gray">(僅限首筆交易)</div>
        </div>
      </div>

      <div class="flex-row">
        <div class="step">3</div>
        <div class="text">
          7 天後，對方獲得 100 元回饋金。 你也可以獲得 50 元回饋金!
          <span><img src="../../assets/images/share/winningNormal@3x.png" width="24" height="24" /></span>
        </div>
      </div>
    </section>

    <div v-show="isLogin">
      <div class="code">
        <div>
          你的優惠序號:
          <span id="inviteCode" style="margin-left: 8px">{{ referralCode }}</span>
        </div>
        <img src="../../assets/images/share/copy@3x.png" width="24" height="24" @click="copy" />
      </div>
      <button class="btn btn-primary" ref="search_btn" @click="copy">複製</button>
    </div>

    <div v-show="!isLogin" class="toolTips-wrap">
      <div class="toolTips">悠遊付會員才能分享優惠序號賺回饋哦</div>
      <button class="btn btn-primary" ref="search_btn" style="margin-top: 16pt" @click="login">立即登入/註冊</button>
    </div>

    <div class="alert" v-show="alert">
      <img src="../../assets/images/share/alertPositive@3x.png" width="80" height="80" />
      <span>複製成功</span>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { getInviteCode } from '../../api/api';

export default {
  name: 'share',
  data() {
    return {
      referralCode: '',
      shareMessage: '',
      alert: false,
      isLogin: false,
    };
  },
  mounted() {
    this.getReferralCode();
    this.checkLoginStatus();
  },
  computed: {
    ...mapGetters(['sessionKey', 'sessionToken']),
  },
  methods: {
    ...mapActions(['sentApp']),
    checkLoginStatus() {
      if (this.sessionKey === null && this.sessionToken === null) {
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    getReferralCode() {
      getInviteCode().then((res) => {
        this.referralCode = res.referral_code;
        this.shareMessage = res.share_message;
      });
    },
    login() {
      this.sentApp({
        action: 'sessionIsNull',
        payload: {},
      });
    },
    copy() {
      this.alert = true;
      this.$copyText(this.shareMessage).then(
        function (e) {},
        function (e) {}
      );
      setTimeout(() => {
        this.alert = false;
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  padding: 32pt 20pt;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  &:nth-child(2) {
    margin: 32px 0 32px 0;
  }
}

.title {
  color: rgb(40, 40, 40);
  font-size: 24px;
  font-family: PingFangTC-Medium;
  text-align: center;
  margin: 40px 0 24px 0;
}

.text {
  font-family: PingFangTC-Medium;
  color: rgb(64, 64, 64);
  font-size: 16px;
}

.text-gray {
  font-family: PingFangTC-Regular;
  color: rgba(40, 40, 40, 0.48);
  font-size: 14px;
}

.desc-wrap {
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: 20px;
    top: 0;
    //border: 1pt dashed rgba(64, 64, 64, 0.2);
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%2340404047' stroke-width='3' stroke-dasharray='3%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    background-size: 100% 90%;
    height: 90%;
    width: 1px;
    z-index: 0;
  }
}

.step {
  border-radius: 50%;
  min-width: 40px;
  min-height: 40px;
  color: rgb(0, 122, 200);
  box-shadow: 0 2pt 4pt 0 rgba(0, 0, 0, 0.4);
  font-family: PingFangTC-Medium;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  z-index: 1;
}

.code {
  border: 1pt solid rgba(64, 64, 64, 0.1);
  border-radius: 8pt;
  color: rgba(40, 40, 40, 0.48);
  font-family: PingFangTC-Regular;
  font-size: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0 16px 0;

  span {
    font-family: PingFangTC-Medium;
    color: rgba(40, 40, 40, 0.8);
    font-size: 16px;
  }
}

.alert {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 160px;
  height: 160px;
  background-color: #fff;
  border-radius: 16pt;
  box-shadow: 0 6pt 10pt 0 rgba(64, 64, 64, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  span {
    font-family: PingFangTC-Medium;
    font-size: 16px;
    color: rgb(64, 64, 64);
    margin-top: 16px;
  }
}

.toolTips-wrap {
  margin-top: 40px;
}

.toolTips {
  background-color: rgb(51, 51, 51);
  color: rgb(249, 249, 249);
  font-family: PingFangTC-Regular;
  font-size: 14px;
  text-align: center;
  border-radius: 3pt;
  padding: 10pt;
  width: 80%;
  margin: 0 auto;
  position: relative;

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgb(51, 51, 51);
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media screen and (max-width: 320px) {
  .container {
    padding: 15pt 20pt;
  }

  .title {
    margin: 16px 0;
  }
  .code {
    margin: 24px 0 16px 0;
  }

  .flex-row {
    &:nth-child(2) {
      margin: 22px 0 20px 0;
    }
  }

  .toolTips-wrap {
    margin-top: 24px;
  }
}
</style>
